export interface GeoPlace {
  lat: string;
  lng: string;
  street: string;
  zip: string;
  city: string;
}

export class GeoPlace implements GeoPlace {
  lat = '';
  lng = '';
  street = '';
  zip = '';
  city = '';
  constructor(){}
}
